import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import Select from "react-select";
import { JdsButton } from "../../../components/jds/JdsButton";
import { CloseIcon } from "../../../components/jds/icons";
import { jdsSelectProps } from "../../../components/jds/selectProps";
import "../../../components/jds/jds.css";
import "../clienteDados.css";
import { useSelector } from "react-redux";

function CardBrandIcon({ brand }) {
  const paymentMethodsRelation = useSelector(
    state => state.app.payment_methods_relation || []
  );
  const paymentMethod = paymentMethodsRelation.find(
    relation => relation.id === brand?.toLowerCase()
  );

  if (!paymentMethod) return null;

  return (
    <img
      alt={brand}
      src={paymentMethod.svg}
      style={{ height: "23px", width: "auto" }}
    />
  );
}

function CardOptionLabel({ card }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <CardBrandIcon brand={card.brand} />
      <span>{`${card.brand} •••• ${card.last_digits} — Val: ${card.expiration_date}`}</span>
    </div>
  );
}

export default function ReactivationModal({
  show,
  onClose,
  onConfirm,
  onConfirmPix = () => {},
  serviceName,
  creditCards = [],
  isLoadingCards = false
}) {
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedMethod, setSelectedMethod] = useState('card');
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    if (!selectedCard) return;
    setIsLoading(true);
    try {
      await onConfirm(selectedCard);
    } catch (error) {
      console.error("Erro ao reativar serviço:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmPix = async () => {
    setIsLoading(true);
    try {
      await onConfirmPix();
    } catch (error) {
      console.error("Erro ao reativar via PIX:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setSelectedCard(null);
    setSelectedMethod('card');
    setIsLoading(false);
    onClose();
  };

  const isConfirmDisabled = isLoading || (selectedMethod === 'card' && !selectedCard);

  return (
    <Modal show={show} onHide={handleClose} centered className="jds-scope">
      <Modal.Header>
        <Modal.Title>Reativar {serviceName}</Modal.Title>
        <JdsButton
          className="cd-modal-close"
          variant="ghost"
          color="neutral"
          size="sm"
          iconOnly
          onClick={handleClose}
          aria-label="Fechar"
        >
          <CloseIcon />
        </JdsButton>
      </Modal.Header>

      <Modal.Body>
        <p>Selecione a forma de pagamento utilizada para reativar o serviço.</p>

        <hr className="jds-divider" />

        {/* Seletor de método de pagamento */}
        <div className="cd-pills" role="group" aria-label="Forma de pagamento">
          <button
            type="button"
            className="cd-pill"
            aria-pressed={selectedMethod === 'card'}
            onClick={() => { setSelectedMethod('card'); setSelectedCard(null); }}
          >
            Cartão de crédito
          </button>
          <button
            type="button"
            className="cd-pill"
            aria-pressed={selectedMethod === 'pix'}
            onClick={() => setSelectedMethod('pix')}
          >
            Pix
          </button>
        </div>

        {/* Seção de cartão de crédito */}
        {selectedMethod === 'card' && (
          <Form.Group>
            <Form.Label>Cartão de crédito</Form.Label>
            <Select
              name="card"
              options={creditCards}
              value={selectedCard}
              onChange={setSelectedCard}
              isLoading={isLoadingCards}
              placeholder="Selecione um cartão..."
              getOptionLabel={(card) => `${card.brand} •••• ${card.last_digits} — Val: ${card.expiration_date}`}
              formatOptionLabel={(card) => <CardOptionLabel card={card} />}
              getOptionValue={(card) => card.hash}
              noOptionsMessage={() => <span>Nenhum cartão cadastrado.</span>}
              {...jdsSelectProps}
              isClearable={false}
            />
          </Form.Group>
        )}

        {/* Seção PIX */}
        {selectedMethod === 'pix' && (
          <div className="cd-alert mb-0" role="alert">
            Ao confirmar, você atesta que o cliente já realizou o pagamento via Pix. O serviço será reativado automaticamente.
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <JdsButton
          variant="outlined"
          color="neutral"
          onClick={handleClose}
          disabled={isLoading}
        >
          Cancelar
        </JdsButton>
        <JdsButton
          onClick={selectedMethod === 'pix' ? handleConfirmPix : handleConfirm}
          disabled={isConfirmDisabled}
        >
          {isLoading ? "Reativando..." : "Confirmar reativação"}
        </JdsButton>
      </Modal.Footer>
    </Modal>
  );
}

